import { render, staticRenderFns } from "./singl.vue?vue&type=template&id=37afcf5b"
import script from "./singl.vue?vue&type=script&lang=js"
export * from "./singl.vue?vue&type=script&lang=js"
import style0 from "./singl.vue?vue&type=style&index=0&id=37afcf5b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports